import { QuestionAdditionalFee } from "@/components/features/items/edit/hotel-policy/_shared/components/main/question/additional-fee/root";

import { useReservationAdditionalFee } from "./hooks/use-additional-fee";

export const QuestionReservationAdditionalFee = () => {
	const {
		isEdited,
		hasError, //

		additionalFees,

		onSetName,

		billingTypeTargetOptions,
		onSetBillingTypeTarget,

		billingTypeTermOptions,
		onSetBillingTypeTerm,

		billingTypeTermValidationOptions,
		onSetBillingTypeTermValidationOptions,
		shouldShowTermValidationSettings,

		onSetApplicableTerm,

		onSetUseKidsPrice,
		kidsAgeOptions,
		onSetKidsMaxAge,
		onSetKidsPriceAmount,

		onSetPriceAmount,

		shouldShowKidsPriceSettings,

		onSetIsNotDiscountTarget,
		onSetIsNotTargetOnDayTrip,
		onSetIsExcludeCancelFeeTarget,
		onSetIsExcludedConsumptionTax,

		append,
		remove,
	} = useReservationAdditionalFee();

	return (
		<QuestionAdditionalFee
			isEdited={isEdited}
			hasError={hasError}
			additionalFees={additionalFees}
			onSetName={onSetName}
			billingTypeTargetOptions={billingTypeTargetOptions}
			onSetBillingTypeTarget={onSetBillingTypeTarget}
			billingTypeTermOptions={billingTypeTermOptions}
			shouldShowKidsPriceSettings={shouldShowKidsPriceSettings}
			onSetBillingTypeTerm={onSetBillingTypeTerm}
			billingTypeTermValidationOptions={billingTypeTermValidationOptions}
			onSetBillingTypeTermValidationOptions={onSetBillingTypeTermValidationOptions}
			shouldShowTermValidationSettings={shouldShowTermValidationSettings}
			onSetApplicableTerm={onSetApplicableTerm}
			kidsAgeOptions={kidsAgeOptions}
			onSetKidsMaxAge={onSetKidsMaxAge}
			onSetKidsPriceAmount={onSetKidsPriceAmount}
			onSetPriceAmount={onSetPriceAmount}
			onSetUseKidsPrice={onSetUseKidsPrice}
			onSetIsExcludeCancelFeeTarget={onSetIsExcludeCancelFeeTarget}
			onSetIsNotDiscountTarget={onSetIsNotDiscountTarget}
			onSetIsNotTargetOnDayTrip={onSetIsNotTargetOnDayTrip}
			onSetIsExcludedConsumptionTax={onSetIsExcludedConsumptionTax}
			append={append}
			remove={remove}
		/>
	);
};

QuestionReservationAdditionalFee.displayName = "QuestionReservationAdditionalFee";
